import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { Topbar } from "@/wizard/Topbar";
import { Wizard } from "@/wizard/Wizard";
import { Success } from "@/wizard/Success";
import { Admin } from "@/admin/Admin";
import { loadPunchout, savePunchout, type Punchout } from "@/lib/punchout";

export function App() {
  // Punchout starts from URL/sessionStorage and can be updated by the
  // intro form when a respondent isn't punched in. Lifted here so the
  // topbar reflects edits made inside the wizard.
  const [punchout, setPunchoutState] = useState<Punchout>(() => loadPunchout());

  const setPunchout = (p: Punchout) => {
    savePunchout(p);
    setPunchoutState(p);
  };

  // Re-sync from URL once on mount (handles deep-link edge cases where
  // sessionStorage exists from a prior visit but new URL params arrive).
  useEffect(() => {
    const fresh = loadPunchout();
    setPunchoutState(fresh);
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Topbar punchout={punchout} />
      <main className="container mx-auto py-4 sm:py-8">
        <Routes>
          <Route
            path="/"
            element={<Wizard punchout={punchout} setPunchout={setPunchout} />}
          />
          <Route path="/thanks/:id" element={<Success />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
    </div>
  );
}
